import React, { memo } from 'react';

import { Alert, Table, Typography } from 'antd';

import CustomCopyToClipboard from 'components/CustomCopyToClipboard';
import { CHECKOUT_ELEMENTS_URL, CHECKOUT_SUN_URL } from 'settings';

import { Icon } from '@eduzz/ui-antd-theme';

interface IProps {
  productId: number | string;
  showOnlyCheckoutSunV4?: boolean;
}

const ShareableLinks = ({ productId, showOnlyCheckoutSunV4 }: IProps) => {
  const links = [{ label: 'Eduzz Checkout Elements', url: `${CHECKOUT_ELEMENTS_URL}/${productId}` }];

  if (!showOnlyCheckoutSunV4) {
    links.push({ label: 'Eduzz Checkout', url: `${CHECKOUT_SUN_URL}/${productId}` });
  }

  return (
    <div className='my-6 flex flex-col gap-3'>
      <Typography.Title level={5}>Link para divulgação</Typography.Title>

      <Alert
        icon={<Icon.Info />}
        type='info'
        message='Seus novos links de Checkout, agora, seguem o padrão de oferta base do MyEduzz. Essa alteração não compromete seus links já criados.'
      />

      <div className='mt-4 flex flex-col gap-2 md:hidden'>
        {links.map(({ label, url }) => (
          <React.Fragment key={label}>
            <Typography.Text>{label}</Typography.Text>
            <CustomCopyToClipboard text={url} hideInput />
          </React.Fragment>
        ))}
      </div>

      <div className='hidden md:block'>
        <Table
          pagination={false}
          rowKey='label'
          columns={[
            { title: 'Checkout', dataIndex: 'label' },
            {
              title: 'Página de pagamento',
              dataIndex: 'url',
              render: (url: string) => <CustomCopyToClipboard text={url} hideInput />
            }
          ]}
          dataSource={links}
        />
      </div>
    </div>
  );
};

export default memo(ShareableLinks);
